import Vue from 'vue';

import App from './App.vue';
import bootstrap from './bootstrap';

bootstrap().then((options) => {
  new Vue({
    ...options,
    render: (h) => h(App),
    mounted() {
      document.getElementById('loading').classList.add('out');
      setTimeout(() => {
        document.getElementById('loading').remove();
      }, 300);
    },
  }).$mount('#app');
});
